import { AuthForm } from '@dtx-company/inter-app/src/components/singleSignOn/auth-form'
import { Box } from '@mui/material'
import { Plan } from '@dtx-company/true-common/src/types/Plan'
import { PlanPurchaseExperienceHeading } from '@app/common/src/components/PlanPurchaseExperience/components/PlanPurchaseExperienceHeading'
import { SocialProvider } from '@dtx-company/true-common/src/types/socialProvider'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { User } from '@app/code/src/types/user.types'
import {
  _BodyBox,
  _Container,
  _SubHeadingText
} from '@app/common/src/components/PlanPurchaseExperience/components/PlanPurchaseExperience.styles'
import { useFlowRouter } from '@dtx-company/inter-app/src/hooks/useFlowRouter'
import { useState } from 'react'
import styled from '@emotion/styled'
import theme from '@app/common/src/theme'

const _PromoCodeNotificationText = styled(Text)`
  && {
    color: ${theme.colors.status.successDark};
    font-weight: bold;
    margin-top: 16px;
    padding: 0 8px;
    text-align: center;
    text-transform: uppercase;
  }
`

interface AccountStepProps {
  currentPlan: Plan | undefined
  selectedPlan: Plan | undefined
  handleAuthFormSubmit: (
    user: User,
    provider: SocialProvider,
    flowpageSlug: string | undefined
  ) => void
}

export function AccountStep(props: AccountStepProps): JSX.Element {
  const flowRouter = useFlowRouter()
  const [isSignIn, setIsSignIn] = useState(false)

  function handleAuthFormToggle(): void {
    setIsSignIn(isSignIn => !isSignIn)
  }

  // Not using `getString` to maintain parity with `PromoCodeInput`
  // but that component will be refactored (hopefully soon)
  const promoCode = flowRouter.query.promoCode

  return (
    <>
      <_BodyBox data-testid={'account-step'}>
        <PlanPurchaseExperienceHeading selectedPlan={props.selectedPlan} />
        {promoCode && (
          <_Container>
            <_PromoCodeNotificationText
              component="p"
              variant="body/small"
              data-testid={'promo-code-next-step-text'}
            >
              Promo code &quot;{promoCode}&quot; will be applied at the payment step
            </_PromoCodeNotificationText>
          </_Container>
        )}
        <_SubHeadingText component="h2" variant="header/subheader" textAlign="left">
          Account
        </_SubHeadingText>
        <Box
          style={{
            marginTop: '17px'
          }}
        >
          <AuthForm
            isSignIn={isSignIn}
            onSubmit={props.handleAuthFormSubmit}
            onToggleMode={handleAuthFormToggle}
          />
        </Box>
        <Spacer mt="64px"></Spacer>
      </_BodyBox>
    </>
  )
}
